import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import LiveCallView from './LiveCallView';
import LiveLinkError from './LiveLinkError';

const LiveLinkHandler = () => {
    const { linkId } = useParams();
    const [searchParams] = useSearchParams();
    const [error, setError] = useState(null);
    const [sessionId, setSessionId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const validateLiveLink = async () => {
            try {
                // Check for error parameter (from expired short link redirect)
                const errorParam = searchParams.get('error');
                if (errorParam === 'expired') {
                    setError('Link expired');
                    setLoading(false);
                    return;
                }

                // Extract token from URL
                const token = searchParams.get('token');
                
                if (!token) {
                    setError('Missing authentication token');
                    setLoading(false);
                    return;
                }

                // Validate token format and expiry
                try {
                    const payload = JSON.parse(atob(token.split('.')[1]));
                    if (payload.exp * 1000 <= Date.now()) {
                        setError('Link expired');
                        setLoading(false);
                        return;
                    }
                } catch (e) {
                    setError('Invalid token format');
                    setLoading(false);
                    return;
                }

                // Make API call to validate live link and get session ID
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/live-link/${linkId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    const errorData = await response.json().catch(() => ({}));
                    setError(errorData.error || 'Link expired');
                    setLoading(false);
                    return;
                }

                const data = await response.json();
                setSessionId(data.session_id);
                setLoading(false);

            } catch (err) {
                console.error('Live link validation error:', err);
                setError('Link expired');
                setLoading(false);
            }
        };

        validateLiveLink();
    }, [linkId, searchParams]);

    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
                <div className="text-center">
                    <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                    <p className="text-gray-600">Validating access...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return <LiveLinkError error={error} />;
    }

    // Redirect to LiveCallView with session ID
    const token = searchParams.get('token');
    return <LiveCallView sessionId={sessionId} token={token} />;
};

export default LiveLinkHandler;